export default [
  {
    path: 'preferences',
    name: 'website.preferences',
    component: () => import('@/views/website/preferences'),
  },
];
